import { useQuery } from "@tanstack/react-query";

import { api } from "./client";
import { refusalFrom } from "./refusal";
import type { components } from "./schema";

export type SupplierResponsiveness = components["schemas"]["SupplierResponsivenessRecord"];

export function useSupplierResponsiveness() {
  return useQuery({
    queryKey: ["supplier-exchange", "requests", "responsiveness"],
    queryFn: async (): Promise<SupplierResponsiveness[]> => {
      const { data, error, response } = await api.GET("/api/v1/supplier-exchange/responsiveness", {});
      if (error || !data) throw refusalFrom(response, error, "Supplier responsiveness could not be read.");
      return data;
    },
  });
}
